export type CheckInFieldParameters = {
  nonResident: any
  nonResidentRooming: any
  resident: any
  residentRooming: any
}

export type SelectedCheckin = {
  bookingId: string
  roomingListIndex: string
  roomingListId: string
}

export enum PreChekInStepEnum {
  Identity = 'Identity',
  PrincipalInfos = 'PrincipalInfos',
  SecondaryInfos = 'SecondaryInfos'
}

export enum IdentityEnum {
  ResidentBase = 'resident',
  RoomingList = 'roomingList'
}

export enum CountryTypeEnum {
  Resident = 'resident',
  NonResident = 'nonResident'
}

export enum FieldCheckInTypeEnum {
  Resident = 'resident',
  ResidentRooming = 'residentRooming',
  NonResident = 'nonResident',
  NonResidentRooming = 'nonResidentRooming'
}

export type StepperForm = {
  step: PreChekInStepEnum
  identity: IdentityEnum
  countryType: CountryTypeEnum
  fieldCheckInType: FieldCheckInTypeEnum
}
